import { useState } from "react";
import DeleteConfirmationModal from "./DeleteConfirmationModal.js";

import { deleteAddress } from "../../network/api/user.js";
function LoactionCard({ address, setRefreshComponent }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleDeleteAddress = () => {
    deleteAddress(address._id).then((response) => {
      setRefreshComponent((prev) => !prev)
      handleCloseDeleteModal();
    }).catch((err) => {
    })
  }

  return (
    <div className="location-details">
      <div className="d-flex justify-content-between ">
        <div className="">
          <h3>{address.fullName}</h3>
          <p>{address.city}</p>
        </div>
        <div className="d-flex bg-transparent dele">
          <span onClick={handleShowDeleteModal} className="bg-transparent" style={{ background: 'transparent' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.0036 6.73046C20.9836 6.73046 20.9536 6.73046 20.9236 6.73046C15.6336 6.20046 10.3536 6.00046 5.12358 6.53046L3.08358 6.73046C2.66358 6.77046 2.29358 6.47046 2.25358 6.05046C2.21358 5.63046 2.51358 5.27046 2.92358 5.23046L4.96358 5.03046C10.2836 4.49046 15.6736 4.70046 21.0736 5.23046C21.4836 5.27046 21.7836 5.64046 21.7436 6.05046C21.7136 6.44046 21.3836 6.73046 21.0036 6.73046Z" fill="#C8C8C8" />
              <path d="M8.50074 5.72C8.46074 5.72 8.42074 5.72 8.37074 5.71C7.97074 5.64 7.69074 5.25 7.76074 4.85L7.98074 3.54C8.14074 2.58 8.36074 1.25 10.6907 1.25H13.3107C15.6507 1.25 15.8707 2.63 16.0207 3.55L16.2407 4.85C16.3107 5.26 16.0307 5.65 15.6307 5.71C15.2207 5.78 14.8307 5.5 14.7707 5.1L14.5507 3.8C14.4107 2.93 14.3807 2.76 13.3207 2.76H10.7007C9.64074 2.76 9.62074 2.9 9.47074 3.79L9.24074 5.09C9.18074 5.46 8.86074 5.72 8.50074 5.72Z" fill="#C8C8C8" />
              <path d="M15.2104 22.7496H8.79039C5.30039 22.7496 5.16039 20.8196 5.05039 19.2596L4.40039 9.18959C4.37039 8.77959 4.69039 8.41959 5.10039 8.38959C5.52039 8.36959 5.87039 8.67959 5.90039 9.08959L6.55039 19.1596C6.66039 20.6796 6.70039 21.2496 8.79039 21.2496H15.2104C17.3104 21.2496 17.3504 20.6796 17.4504 19.1596L18.1004 9.08959C18.1304 8.67959 18.4904 8.36959 18.9004 8.38959C19.3104 8.41959 19.6304 8.76959 19.6004 9.18959L18.9504 19.2596C18.8404 20.8196 18.7004 22.7496 15.2104 22.7496Z" fill="#C8C8C8" />
              <path d="M13.6581 17.25H10.3281C9.91813 17.25 9.57812 16.91 9.57812 16.5C9.57812 16.09 9.91813 15.75 10.3281 15.75H13.6581C14.0681 15.75 14.4081 16.09 14.4081 16.5C14.4081 16.91 14.0681 17.25 13.6581 17.25Z" fill="#C8C8C8" />
              <path d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z" fill="#C8C8C8" />
            </svg>
          </span>
        </div>
      </div>
      <div className="d-flex  justify-content-between align-items-end">
        <div>
          <p className="type">رقم المنزل:<small> {address.house}</small> </p>
          <p className="desc ">{address.address}</p>
          <p className="phone">{address.mobileNumber}</p>
        </div>
        <DeleteConfirmationModal
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteAddress}
          address_id={address._id}
        />
      </div>
    </div>
  )
}
export default LoactionCard;